export class CommentFiche {
  id :number ;
  ficheDate: any;
  text: string;
  creationDate: any;
  type: string;
  username: string;
  toUpdate:boolean;
  addedBy:any;
}



// WEBPACK FOOTER //
// ./src/app/model/comment.ts